<span
  class="user-avatar"
  [class.user-avatar--light]="tone === 'light'"
  [class.user-avatar--primary]="tone === 'primary'"
>
  @if (imageUrl) {
    <img
      class="user-avatar__image"
      [src]="imageUrl"
      [alt]="userName"
      (error)="handleUserAvatarImageError()"
    >
  } @else {
    <span [class]="size === 'large'  ? 'user-avatar__initials' : 'user-avatar__initials--small'" aria-hidden="true">{{ initials }}</span>
  }
</span>
